// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","paginationActive":"Pagination_paginationActive__UYleq"};